export default {
  SET_ACTIVE_POPUP(state, data) {
    state.activePopups = 'status_default_popup'
    state.activePopups = data
  },

  SET_HIDE_POPUP(state) {
    state.activePopups = ''
  }
}